module.exports = __webpack_public_path__ + "img/m.f0581435.svg";